import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../environments/environment";
import { BaseService } from "../base.service";
import firebase from "firebase";
import * as CryptoJS from "crypto-js";

@Component({
  selector: "app-model-player",
  templateUrl: "./model-player.component.html",
  styleUrls: ["./model-player.component.css"],
})
export class ModelPlayerComponent implements OnInit {
  @Input() data: any;
  @Input() playerStatus: any;
  @Input() position: any;
  appConstant: any;
  player;
  isLogin: boolean;
  encodeUrl: any;
  watchlistLoader = false;
  likeLoader = false;
  dislikeLoader = false;
  constructor(
    private router: Router,
    private service: BaseService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.data.likeDislikeDisable = this.data.is_user_likeDislike;
    }
    if (localStorage.getItem(environment.localStorageKey)) {
      this.isLogin = true;
    }
    this.appConstant = environment;
  }

  singIn(event) {
    let url;
    if (this.data.type === "video") {
      url = "/video-detail/" + this.data.public_id;
    } else {
      url = "/series/" + this.data.public_id;
    }
    this.encodeUrl = CryptoJS.AES.encrypt(
      JSON.stringify(url),
      environment.secretkey
    ).toString();
    this.router.navigate(["/login"], {
      queryParams: { public_id: this.encodeUrl, event: event },
    });
  }
  likeDislike(status) {
    if (status == 1) {
      this.likeLoader = true;
    } else if (status == 0) {
      this.dislikeLoader = true;
    }
    const sendData = {
      like_id: this.data.public_id,
      status: status,
      type: this.data.type,
      season_id: this.data.season_id,
    };
    if (localStorage.getItem(environment.localStorageKey)) {
      this.data.likeDislikeDisable = status;
      this.service.likeDislike(sendData).subscribe(
        (res) => {
          if (status === 1) {
            this.likeLoader = false;
            this.data.total_like = this.data.total_like + 1;
            if (this.service.contentType === "popular_courses") {
              this.popular_courses(status);
            } else if (this.service.contentType === "home") {
              // this.localData(status);
              localStorage.removeItem(environment.pagesLocalStorageKey);
            }
            if (this.data.is_user_likeDislike !== null) {
              if (this.data.total_dislike > 0) {
                this.data.total_dislike = this.data.total_dislike - 1;
              }
            }
          } else {
            this.dislikeLoader = false;
            if (this.service.contentType === "popular_courses") {
              this.popular_courses(status);
            } else if (this.service.contentType === "home") {
              // this.localData(status);
              localStorage.removeItem(environment.pagesLocalStorageKey);
            }
            if (this.data.is_user_likeDislike !== null) {
              if (this.data.total_like > 0) {
                this.data.total_like = this.data.total_like - 1;
              }
            }
            this.data.total_dislike = this.data.total_dislike + 1;
          }
          this.data.is_user_likeDislike = status;
        },
        (err) => {
          this.likeLoader = false;
          this.dislikeLoader = false;
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
        }
      );
    }
  }
  favoriteVideo() {
    // this.isFavorite = !this.isFavorite;
    const id = {
      favorite_id: this.data.public_id,
      type: this.data.type,
      season_id: this.data.season_id,
    };
    if (localStorage.getItem(environment.localStorageKey)) {
      this.watchlistLoader = true;
      if (this.data.is_favorite) {
        if (!this.data.is_favorite.id) {
          this.service.addFavorite(id).subscribe(
            (detail) => {
              this.data.is_favorite.id = detail.id;
              this.data.is_favorite.is_favorite = "yes";
              this.watchlistLoader = false;
              this.toastr.success("Added to watchlist", "Success!", {
                positionClass: "toast-bottom-left",
                closeButton: true,
              });
              if (this.service.contentType === "popular_courses") {
                this.popular_courses(detail);
              } else if (this.service.contentType === "home") {
                // this.localData(detail);
                localStorage.removeItem(environment.pagesLocalStorageKey);
              }
              if (environment.analyticsStatus) {
                const analytics = firebase.analytics();
                analytics.logEvent("like");
              }
            },
            (err) => {
              this.watchlistLoader = false;
              this.toastr.error(err.error.message, "OOPS!", {
                closeButton: true,
              });
            }
          );
        } else {
          this.service.removeFavorite(this.data.is_favorite.id).subscribe(
            (detail) => {
              this.data.is_favorite.id = "";
              this.data.is_favorite.is_favorite = "no";
              this.watchlistLoader = false;
              this.toastr.success("Removed from watchlist", "Success!", {
                positionClass: "toast-bottom-left",
                closeButton: true,
              });
              if (this.service.contentType === "popular_courses") {
                this.popular_courses(detail);
              } else if (this.service.contentType === "home") {
                // this.localData(detail);
                localStorage.removeItem(environment.pagesLocalStorageKey);
              }
              if (environment.analyticsStatus) {
                const analytics = firebase.analytics();
                analytics.logEvent("unlike");
              }
            },
            (err) => {
              this.watchlistLoader = false;
              this.toastr.error(err.error.message, "OOPS!", {
                closeButton: true,
              });
            }
          );
        }
      }
    }
  }

  localData(detail) {
    const localdata = JSON.parse(
      localStorage.getItem(environment.pagesLocalStorageKey)
    );
    if (localdata) {
      const index = localdata
        .map((el) => {
          return el.hasOwnProperty("home");
        })
        .indexOf(true);
      if (index !== -1) {
        localdata[index].home.subcategory.map((data) => {
          data.content.map((el) => {
            if (el.public_id === this.data.public_id) {
              if (detail === 1 || detail === 0) {
                el.is_user_likeDislike = detail;
              } else {
                el.is_favorite = detail;
              }
            }
          });
        });
        localStorage.setItem(
          environment.pagesLocalStorageKey,
          JSON.stringify(localdata)
        );
      }
    }
  }
  popular_courses(detail) {
    const localdata = JSON.parse(
      localStorage.getItem(environment.pagesLocalStorageKey)
    );
    if (localdata) {
      const index = localdata
        .map((el) => {
          return el.hasOwnProperty("popular_courses");
        })
        .indexOf(true);
      if (index !== -1) {
        localdata[index].popular_courses.map((data) => {
          if (data.public_id === this.data.public_id) {
            if (detail === 1 || detail === 0) {
              data.is_user_likeDislike = detail;
            } else {
              data.is_favorite = detail;
            }
          }
        });
        localStorage.setItem(
          environment.pagesLocalStorageKey,
          JSON.stringify(localdata)
        );
      }
    }
  }
}
